import { RectangleGroupIcon } from '@heroicons/react/24/outline'

import Breadcrumb from '@/components/navigation/Breadcrumb'

import { FiltersRow } from './filters/FiltersRow'
import { getColumns } from './table/Columns'
import { DataTable } from './table/DataTable'
import { TableContextProvider } from './table/TableContext'
import { useState } from 'react'
import { Category } from '@/interfaces/containerCategory'

export default function CategoryList() {
  const [showEditCategory, setShowEditCategory] = useState(false)
  const [showDeleteCategory, setShowDeleteCategory] = useState(false)
  const [categoryToEdit, setCategoryToEdit] = useState<Category>()
  const [categoryToDelete, setCategoryToDelete] = useState<number>()

  return (
    <div>
      <Breadcrumb
        icon={<RectangleGroupIcon className="h-6 text-gray-500" />}
        paths={[{ name: 'Logística' }, { name: 'Categorías' }]}
      />
      <FiltersRow />
      <TableContextProvider>
        <DataTable
          categoryToDelete={categoryToDelete}
          categoryToEdit={categoryToEdit}
          columns={getColumns(
            setShowEditCategory,
            setCategoryToEdit,
            setShowDeleteCategory,
            setCategoryToDelete
          )}
          onClose={() => setShowEditCategory(false)}
          onCloseDelete={() => setShowDeleteCategory(false)}
          showDeleteCategory={showDeleteCategory}
          showEditCategory={showEditCategory}
        />
      </TableContextProvider>
    </div>
  )
}
